import { render } from "./IconNewDoc.vue?vue&type=template&id=2a476b46&scoped=true"
import script from "./IconNewDoc.vue?vue&type=script&lang=js"
export * from "./IconNewDoc.vue?vue&type=script&lang=js"

import "./IconNewDoc.vue?vue&type=style&index=0&id=2a476b46&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a476b46"]])

export default __exports__